/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { cancel, fork, take } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import { matchesApiCancelKey } from '../apiCancelKeys';
import workerSaga from './workerSaga';

// ------------------------------------
// Watchers
// ------------------------------------

export function* takeLatestUntilApiCancel(actionType, cancelKey = actionType) {
  let lastTask;

  while (true) {
    const action = yield take([actionType, ActionConstants.CANCEL_API_REQUEST]);

    if (action.type === ActionConstants.CANCEL_API_REQUEST) {
      if (matchesApiCancelKey(action.payload, cancelKey) && lastTask) {
        yield cancel(lastTask);
        lastTask = null;
      }
      continue;
    }

    if (lastTask) {
      yield cancel(lastTask);
    }
    lastTask = yield fork(workerSaga, action);
  }
}

export default function* merchantListingWatcher(): Generator<any, void, unknown> {
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_MERCHANT_LIST
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.MERCHANT_SEARCH
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_MERCHANT_MIGRATION_DATA
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.MIGRATED_MERCHANT_SEARCH
  );
}
